import React from 'react'


const MainCampaigns = ({history}) => {

  return (
    <div>
        <div className='global-container-cards'>
            <div className='container-cards'>
                <div className='card-style-campaign'>
                  <div className='icon-plus-campaigns'>+</div>
                  <button className='button-card-campaign'
                  onClick={()=>
                    history.push(
                      '/Admin/AdminCampaigns'                      
                  )
                  }
                  >Crear</button>                  
                </div>                
            </div>
            <div className='container-cards'>
                <div className='card-style-campaign'>                  
                  <button 
                  className='button-card-campaign'
                  onClick={()=>
                    history.push(
                      '/Admin/ManageCampaigns'                      
                  )
                  } 
                  >Gestionar Campaña
                  </button>                  
                </div>                
            </div>
        </div>
    </div>
  )
}

export default MainCampaigns